const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || '';
const COMPANY_LOGO = process.env.REACT_APP_COMPANY_LOGO || '';

export { BACKEND_URL, COMPANY_NAME, COMPANY_LOGO };

